import { render, staticRenderFns } from "./IdCardMask.vue?vue&type=template&id=2a28e570&scoped=true"
import script from "./IdCardMask.vue?vue&type=script&lang=js"
export * from "./IdCardMask.vue?vue&type=script&lang=js"
import style0 from "./IdCardMask.vue?vue&type=style&index=0&id=2a28e570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a28e570",
  null
  
)

export default component.exports